import {storeSalesPlanDuplicateDraft} from "@/services/duplicate/salesPlanDraft";

export default {
  methods: {
    openDuplicateConfirmModal(value) {
      const resolvedValue = typeof Event !== 'undefined' && value instanceof Event
          ? this.model ?? null
          : value ?? this.model ?? null;

      this._duplicateTargetModel = resolvedValue;
      this.$set(this, 'duplicateConfirmModalShow', true);
    },
    closeDuplicateConfirmModal() {
      this.$set(this, 'duplicateConfirmModalShow', false);
      this._duplicateTargetModel = null;
    },
    async confirmDuplicate() {
      const targetModel = this._duplicateTargetModel ?? this.model ?? null;
      if (!targetModel) {
        return null;
      }

      this.$set(this, 'duplicateLoading', true);

      try {
        const duplicateDraft = storeSalesPlanDuplicateDraft(targetModel);
        if (!duplicateDraft) {
          const error = new Error('Failed to save duplicate draft.');
          if (typeof this.failedAlert === 'function') {
            this.failedAlert(error);
          }
          return null;
        }

        await this.$router.push({name: 'sales_plans.create'});
        this.closeDuplicateConfirmModal();
        return duplicateDraft;
      } catch (error) {
        if (typeof this.failedAlert === 'function') {
          this.failedAlert(error);
        }
        return null;
      } finally {
        this.$set(this, 'duplicateLoading', false);
      }
    },
    handleDuplicate(value) {
      return this.openDuplicateConfirmModal(value);
    },
  },
};
